import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-stone-800 text-white py-10 md:py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row justify-between gap-8 md:gap-10 mb-8 md:mb-10">
          <div className="w-full lg:w-1/3">
            <img
              src="https://storage.readdy-site.link/project_files/f1a4733f-f142-44b4-9a4b-319ee3c3a442/cf5d4cea-d623-4733-86a8-803e415ede74_20161028_-yeong-bin-ho--ro-go_ol1574127236.png?v=7dd96618540c35f269119a9b3765e2fd"
              alt="YOUNGBIN HOTEL"
              className="h-9 md:h-10 object-contain mb-3 md:mb-4 brightness-0 invert"
            />
            <p className="text-stone-400 text-xs md:text-sm leading-relaxed whitespace-pre-line">{t('footer_desc')}</p>
          </div>
          <div className="flex flex-wrap gap-8 md:gap-10">
            <div>
              <p className="text-xs text-amber-400 tracking-widest uppercase mb-3 md:mb-4">{t('footer_hotel_info')}</p>
              <ul className="flex flex-col gap-1.5 md:gap-2">
                <li><Link to="/greeting" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_about')}</Link></li>
                <li><Link to="/rooms" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_rooms')}</Link></li>
                <li><Link to="/facilities" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_services')}</Link></li>
                <li><Link to="/directions" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_contact')}</Link></li>
              </ul>
            </div>
            <div>
              <p className="text-xs text-amber-400 tracking-widest uppercase mb-3 md:mb-4">{t('footer_support')}</p>
              <ul className="flex flex-col gap-1.5 md:gap-2">
                <li><Link to="/reservation" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_reserve')}</Link></li>
                <li><a href="mailto:youngbinhotel@hotmail.com" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_email_inquiry')}</a></li>
                <li><a href="tel:0222771141" className="text-stone-400 text-xs md:text-sm hover:text-white cursor-pointer">{t('footer_phone_inquiry')}</a></li>
              </ul>
            </div>
          </div>
        </div>
        {/* 개인정보 관리담당자 */}
        <div className="border-t border-stone-700 pt-5 pb-4 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-6">
          <span className="text-amber-400/80 text-xs font-semibold tracking-widest uppercase whitespace-nowrap">개인정보 관리담당자</span>
          <div className="flex flex-wrap items-center gap-4">
            <span className="text-stone-300 text-xs">권대성</span>
            <a href="tel:0222771141" className="flex items-center gap-1.5 text-stone-400 text-xs hover:text-amber-300 transition-colors cursor-pointer whitespace-nowrap">
              <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-phone-line" /></div>
              02-2277-1141
            </a>
            <a href="mailto:youngbinhotel@hotmail.com" className="flex items-center gap-1.5 text-stone-400 text-xs hover:text-amber-300 transition-colors cursor-pointer whitespace-nowrap">
              <div className="w-3.5 h-3.5 flex items-center justify-center"><i className="ri-mail-line" /></div>
              youngbinhotel@hotmail.com
            </a>
          </div>
        </div>

        <div className="border-t border-stone-700 pt-5 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-xs">{t('footer_copyright')}</p>
          <div className="flex gap-4">
            <Link to="/privacy" className="text-stone-500 text-xs hover:text-white cursor-pointer whitespace-nowrap">{t('footer_privacy')}</Link>
            <a href="http://www.youngbinhotel.com/shop_info/agree.htm" target="_blank" rel="nofollow noreferrer" className="text-stone-500 text-xs hover:text-white cursor-pointer whitespace-nowrap">{t('footer_terms')}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
